// extracted by css-extract-rspack-plugin
var _1 = "yLM7Xbga0JBY4u3j";
var _2 = "NkSL8LdDlx86lU5K";
var _3 = "RCO9oK9ATcTI7uzN";
var _4 = "sYUSKGEwJLglfozx";
var _5 = "hSZPDstrJY9ItR1_";
var _6 = "VwzyM8cgzFElFjpr";
var _7 = "MnAAklaahoOFPx93";
export { _1 as "tabs", _2 as "tiles", _3 as "tilesContained", _4 as "tilesDefault", _5 as "tilesFullWidth", _6 as "titles", _7 as "titlesFullWidth" }
// extracted by css-extract-rspack-plugin
var _1 = "yLM7Xbga0JBY4u3j";
var _2 = "NkSL8LdDlx86lU5K";
var _3 = "RCO9oK9ATcTI7uzN";
var _4 = "sYUSKGEwJLglfozx";
var _5 = "hSZPDstrJY9ItR1_";
var _6 = "VwzyM8cgzFElFjpr";
var _7 = "MnAAklaahoOFPx93";
export { _1 as "tabs", _2 as "tiles", _3 as "tilesContained", _4 as "tilesDefault", _5 as "tilesFullWidth", _6 as "titles", _7 as "titlesFullWidth" }
